import type { BreakpointsOptions } from '@mui/system';

// default MUI breakpoints
export const breakpoints: BreakpointsOptions = {
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  values: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1110,
    xl: 1536,
  },
};
